import { APIClient } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';

function withRouter(Component: any) {
    function ComponentWithRouterProp(props: any) {
        const apiClient = new APIClient(process.env.REACT_APP_API_URL || '');

        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const selectLayoutState = (state: any) => state;
        const loginpageData = createSelector(selectLayoutState, (state: any) => ({
            user: state.Login.user,
            error: state.Login.error,
            errorMsg: state.Login.errorMsg,
            config: state.Login.userConfig
        }));
        const { user } = useSelector(loginpageData);
        const { config } = useSelector(loginpageData);

        return <Component {...props} router={{ location, navigate, params, apiClient, user, config }} />;
    }

    return ComponentWithRouterProp;
}

export default withRouter;
